import { getDownloadLinkWithGaId, getGaId } from '@modules/helper';
import { removeError } from '@store/actions';
import { POP_RUN_DOWNLOAD, POP_RUN_SCRIPT } from '@constants';

// Очистка ошибки из редакса
export const clearError = (item) => (dispatch) => dispatch(removeError(item));

export const checkDownloadStandaloneFromBanner = () => {
  try {
    const saveDownloadLink = JSON.parse(localStorage.getItem(POP_RUN_DOWNLOAD));
    const banner = document.getElementById('fullscreen-banner');

    const openDownload = (attempt = 60) => {
      if (!attempt) return;

      const gaId = getGaId();

      if (gaId && gaId !== 'nid') {
        const fileName = saveDownloadLink.fileName.replace('_null', `_${gaId}`);

        window.dataLayer &&
          window.dataLayer.push({
            'event': 'ga4_Event',
            'evName': 'file_download',
            'FileExtension': saveDownloadLink.fileExtension,
            'FileName': fileName,
            'Click URL': saveDownloadLink.url,
            'Click Text': saveDownloadLink.text,
          });
        window.open(getDownloadLinkWithGaId(saveDownloadLink.url), '_blank');

        return;
      }

      return setTimeout(() => {
        openDownload(attempt - 1);
      }, 1000);
    };

    localStorage.setItem(POP_RUN_SCRIPT, 'true');
    localStorage.removeItem(POP_RUN_DOWNLOAD);

    if (banner) {
      banner.remove();
    }

    if (saveDownloadLink) {
      openDownload();
    }
  } catch (e) {
    console.error(e);
  }
};
